import { createContext, useContext } from 'react'
import { AnalyticsAdapter } from '../../../utils/analytics/analyticsAdapter'

type AnalyticsContextType = {
  analytics?: AnalyticsAdapter
}

export const AnalyticsContext = createContext<AnalyticsContextType>({
  analytics: undefined,
})

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext)

  if (!context) {
    throw new Error(
      'Swashbuckle Analytics [Error]: The "useAnalytics" must be used in a child of AnalyticsProvider'
    )
  }

  return context
}
